export default "<spec-app-type10-mixed-table #table [clickHandler]=\"clickHandler\" [allowCreate]=\"true\"></spec-app-type10-mixed-table>\n";